import { ConfirmDialog } from '../../../common/dialogs/ConfirmDialog';
import { Typography, colors } from '@sweep-io/sweep-design';
import { Stack } from '@mui/material';

interface OrgAlreadyConnectedConfirmDialogProps {
  isOpen: boolean;
  isSameAccount: boolean;
  onCancel: () => void;
  onForce: () => void;
}

const OrgAlreadyConnectedConfirmDialog = ({
  isOpen,
  isSameAccount,
  onCancel,
  onForce,
}: OrgAlreadyConnectedConfirmDialogProps) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Salesforce org already connected"
      handleClose={onCancel}
      onCancel={onCancel}
      onConfirm={onForce}
      cancelText="Cancel"
      confirmText="Connect anyway"
      confirmButtonType="error"
      showCloseButton
      dialogContentSx={{ pt: 0, pr: 6, width: '450px', height: '105px' }}
    >
      <Stack gap={2}>
        <Typography variant="body" color={colors.grey[800]}>
          This Salesforce org is already connected to{' '}
          {isSameAccount ? 'this Sweep account' : 'another Sweep account'}. It is not recommended to
          connect the same org multiple times.
        </Typography>
      </Stack>
    </ConfirmDialog>
  );
};

export default OrgAlreadyConnectedConfirmDialog;
